import { useMemo } from 'react';

import { useFleetMembers } from 'src/api/queries/fleet';
import { FlexDivider, Sheet } from 'src/components';
import { DashboardNumber } from './DashboardNumber';
import { OverviewCompliance } from './OverviewCompliance';

export function Overview({ componentLocation }: { componentLocation: string }) {
  const members = useFleetMembers();

  const numberOfMembers = members.data?.users?.length ?? 0;
  const numberOfDevices = useMemo(() => {
    if (!members.data?.users) {
      return 0;
    }

    return (
      members.data.users
        .map((u) => u.devices?.length)
        .reduce((acc, current) => (acc ?? 0) + (current ?? 0), 0) ?? 0
    );
  }, [members.data?.users]);

  return (
    <Sheet className="lxl:flex-row">
      <div className="flex flex-1 gap-16">
        <DashboardNumber
          dataCy="members-count"
          value={numberOfMembers}
          label="Total members"
        />

        <FlexDivider />

        <DashboardNumber
          dataCy="devices-count"
          value={numberOfDevices}
          label="Total devices"
        />
      </div>

      <div className="flex flex-1 gap-16">
        <FlexDivider className="hidden lxl:flex" />

        <DashboardNumber
          label="Seats on next billing"
          value={numberOfMembers}
        />
        <FlexDivider />

        <OverviewCompliance componentLocation={componentLocation} />
      </div>
    </Sheet>
  );
}
